<script setup lang="ts">
import {ref } from 'vue'

import qs from 'qs'

import $api from '../config/api'
import $http from 'devcude-common/src/utils/DcHttp'
import DcDictRadio from 'dc-comp-sdk/src/components/form/DcDictRadio.vue'

const v = ref(false)
const emit = defineEmits(['finish'])

async function show(data) {
  console.log(data)
  fd.value = Object.assign({}, formData, data);
  if (fd.value.shipType === 'NOW' && fd.value.shipTimeRange) {
    const match = fd.value.shipTimeRange.match(/(\d{2}:\d{2})~(?:次日 )?(\d{2}:\d{2})$/)
    if (match) fd.value.shipTimeSlot = `${match[1]}-${match[2]}`
  }
  await loadSameDayShipTimes()
  v.value = true
}


const SAVE_URL = $api.shpOrder.updateShipDate

const formData = {
  id:'',
  shipType: '',
  shipDate: '',
  shipTimeSlot: '',
  shipTimeRange: ''
}

const sameDayShipTimes = ref<any[]>([])

async function loadSameDayShipTimes() {
  if (sameDayShipTimes.value.length) return
  const { data } = await $http.post($api.shpOrder.sameDayShipTimes)
  sameDayShipTimes.value = data.items || []
}

const formInst = ref()
const fd = ref(Object.assign({}, formData))

const formRules = ref({
  shipType: [
    { required: true, message: '配送方式不能爲空', trigger: 'blur' }
  ],
  shipDate: [
    {
      required: () => fd.value.shipType !== 'NOW',
      message: '配送日期不能爲空',
      trigger: 'blur'
    }
  ],
  shipTimeSlot: [
    {
      required: () => fd.value.shipType === 'NOW',
      message: '即日送貨時段不能爲空',
      trigger: 'change'
    }
  ]
})


function handleReset() {
  fd.value = Object.assign({}, formData)
}

async function handleSave() {
  let checkForm = await formInst.value.validate()
  if (!checkForm) {
    return
  }
  try {
    await $http.post(SAVE_URL, qs.stringify(fd.value), { showTips: true })
    emit('finish')
    v.value = false;
  } catch (e: any) {
    if (e.status === 400) {
      console.log(e)
      let errorTips = new Map()
      e.data.errorFields.forEach((e: any) => {
        errorTips.set(e.name, e.message)
      })
      formInst.value.fields.forEach((e: any) => {
        if (errorTips.get(e.prop)) {
          e.validateState = 'error'
          e.validateMessage = errorTips.get(e.prop)
          //手动校验  显示错误文本
          formInst.value.validateField(e.prop)
        }
      })
    }
  }
}
defineExpose({ show })
</script>

<template>
  <el-dialog v-model="v" @close="handleClose" width="600px">
    <el-form ref="formInst" :model="fd" :rules="formRules" size="large" label-width="auto"
             class="bg-[#fff] !min-w-[500px]">
      <el-form-item label="配送方式" prop="shipType">
        <DcDictRadio v-model="fd.shipType" dict-type="DCSHP_SHIP_TYPE"></DcDictRadio>

      </el-form-item>

      <el-form-item v-if="fd.shipType === 'NOW'" label="配送時段" prop="shipTimeSlot">
        <el-select v-model="fd.shipTimeSlot" placeholder="選擇即日送貨時段" class="w-full">
          <el-option
            v-for="item in sameDayShipTimes"
            :key="`${item.start}-${item.end}`"
            :label="`${item.start}-${item.nextDay ? '次日 ' : ''}${item.end}`"
            :value="`${item.start}-${item.end}`"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-else label="配送時間" prop="shipDate">
        <el-date-picker
          size="default"
          v-model="fd.shipDate"
          type="datetime"
          value-format="YYYY-MM-DD HH:mm"
          format="YYYY-MM-DD HH:mm"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </el-form-item>

      <div class="flex justify-center">
        <el-button @click="handleSave" type="primary" size="large">保存</el-button>
        <el-button @click="handleReset" size="large">重置</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<style></style>
